import type { IItemCategory } from './../features/wizard/types/index';

// TODO[REFACTORING] Delete same const in wizard constants

export const categories: IItemCategory[] = [
  {
    id: 'a',
    label: 'FORM.CATEGORY_A',
  },
  {
    id: 'b',
    label: 'FORM.CATEGORY_B',
  },
  {
    id: 'c',
    label: 'FORM.CATEGORY_C',
  },
  {
    id: 'd',
    label: 'FORM.CATEGORY_D',
  },
  {
    id: 'e',
    label: 'FORM.CATEGORY_E',
  },
  {
    id: 'h',
    label: 'FORM.CATEGORY_H',
  },
  {
    id: 'i',
    label: 'FORM.CATEGORY_I',
  },
  {
    id: 'j',
    label: 'FORM.CATEGORY_J',
  },
  {
    id: 'k',
    label: 'FORM.CATEGORY_K',
  },
];
